import React from "react";
// import TableComandas from "../components/TableComandas";
import AppClienteRecepcionReactTable from "../table/AppClienteRecepcionReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const ClientesRecepcion = () => {
  return (
    <>
      <AppClienteRecepcionReactTable />
      {/* <TableComandas /> */}

    </>
  );
};

export default ClientesRecepcion;
